'use strict';

/**
 * View for rendering the storages
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var NavigationStoragesItemView = require('./navigation-storages-list-item');

var template = require('../../templates/partials/navigation-storages-list.hbs');

var NavigationStoragesListView = ColidoCompositeView.extend({
    template: template,

    childView: NavigationStoragesItemView,

    childViewContainer: 'ul',

    isVisible: false,

    collectionEvents: {
        'add remove': 'checkReveal',
    },

    onShow: function() {
        this.checkReveal();
    },

    onBeforeRender: function() {
        this.isVisible = this.$('ul').hasClass('is-visible');
    },

    onRender: function() {
        this.$('ul').toggleClass('is-visible', this.isVisible);
        this.prependOverviewItem();
    },

    prependOverviewItem: function() {
        var catalog = this.getOption('catalog');
        var prependItem = $('<li class="prepend-menu-item"><a href="/catalogs/' + catalog.id + '/storages">' + App.t('collection::locations:storages:overview') + '</a></li>');
        this.$('ul').prepend(prependItem);
    },

    checkReveal: function() {
        this.$('ul').toggleClass('revealable', this.collection.length > 6);
    },
});

module.exports = NavigationStoragesListView;